@if (banner) {
  <div class="ambiente-banner" [class.dev]="banner.classe === 'dev'" [class.hml]="banner.classe === 'hml'"
       role="status" data-testid="ambiente-banner">
    {{ banner.rotulo }}
  </div>
}
